import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as notifikaceActions from "../../actions/notifikaceActions";
const {sinkEvent} = commons;
import TablePanel from "../../components/TablePanel";
import CustomCheckbox from "../../components/CustomCheckbox";
import NotifikaceForm from "../../forms/NotifikaceForm";
import NotifikaceApi from "../../api/gen/cgo/NotifikaceApi";
import * as EnumFormaDoruceniNotifikaceInfo from "../../api/EnumFormaDoruceniNotifikaceInfo";
import * as EnumStavObjednavkaNotifikaceInfo from "../../api/EnumStavObjednavkaNotifikaceInfo";
import * as EnumUdalostNotifikaceInfo from "../../api/EnumUdalostNotifikaceInfo";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Notifikace
 */
class NotifikacePage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(notifikaceActions.fetchNotifikaceIfNeeded());
        this.props.dispatch(notifikaceActions.fetchNotifikaceHelpIfNeeded());
    };

    handleCreateNotifikace = () => {
        const {notifikaceHelpList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            NotifikaceForm,
            {
                onSubmit: (data) => {
                    return NotifikaceApi.createNotifikaceObj(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(notifikaceActions.invalidateNotifikace());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                notifikaceHelp: notifikaceHelpList.rows,
                // Některé checkboxy jsou povinné ale implicitně jsou null
                initialValues: {
                    zapsalZakaznik: false,
                    zapsalOperator: false,
                    prilozitPdf: false,
                    neaktivni: false,
                    interniEmailNotifikace: false,
                },
            },
            t('admin.new_notification'),
            {size: "full"}
        ));
    };

    handleEditNotifikace = (notifikace) => {
        const {notifikaceHelpList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            NotifikaceForm,
            {
                onSubmit: (data) => {
                    return NotifikaceApi.updateNotifikaceObj(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(notifikaceActions.invalidateNotifikace());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                notifikaceHelp: notifikaceHelpList.rows,
                initialValues: notifikace,
            },
            t('admin.notification_change'),
            {size: "full"}
        ));
    };

    handleVcetneNeaktivnich = (e) => {
        const {notifikaceList} = this.props;
        this.props.dispatch(notifikaceActions.filterNotifikace({
            ...notifikaceList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (notifikace) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditNotifikace.bind(this, notifikace))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {notifikaceList, t} = this.props;
        let content;
        if (notifikaceList.fetched) {
            if (notifikaceList.rows.length !== 0) {
                content = notifikaceList.rows.map(notifikace => {
                    return <CardBody key={notifikace.id} className={notifikace.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(notifikace)} onClick={this.handleEditNotifikace.bind(this, notifikace)}>
                            <Row>
                                <Col xs={2}>{notifikace.udalostNotifikace ? EnumUdalostNotifikaceInfo.getCaption(notifikace.udalostNotifikace, t) : "-"}</Col>
                                <Col xs={2}>{notifikace.stavObjednavka ? EnumStavObjednavkaNotifikaceInfo.getCaption(notifikace.stavObjednavka, t) : "-"}</Col>
                                <Col xs={2}>{notifikace.formaDoruceni ? EnumFormaDoruceniNotifikaceInfo.getCaption(notifikace.formaDoruceni, t) : "-"}</Col>
                                <Col xs={2}>{notifikace.zapsalZakaznik ? t('yes') : t('no')}</Col>
                                <Col xs={2}>{notifikace.zapsalOperator ? t('yes') : t('no')}</Col>
                                <Col xs={1}>{notifikace.prilozitPdf ? t('yes') : t('no')}</Col>
                                <Col xs={1}>{notifikace.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('admin.no_notification')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = notifikaceList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('admin.notifications')}
            subtitle={t('admin.system_operator_notifications')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateNotifikace}>{t('new_f')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={2}>{t('labels.event')}</Col>
                            <Col xs={2}>{t('order.state_one')}</Col>
                            <Col xs={2}>{t('labels.delivery_form')}</Col>
                            <Col xs={2}>{t('customer_wrote_down')}</Col>
                            <Col xs={2}>{t('operator_wrote_down')}</Col>
                            <Col xs={1}>{t('attach_pdf')}</Col>
                            <Col xs={1}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        notifikaceList: utils.storeFromArea(state, notifikaceActions.NOTIFIKACE_LIST_AREA),
        notifikaceHelpList: utils.storeFromArea(state, notifikaceActions.NOTIFIKACE_HELP_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(NotifikacePage));
